var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6972 2.26464C16.1009 1.86096 16.1009 1.20645 15.6972 0.802764C15.2936 0.399079 14.639 0.399079 14.2354 0.802764L8 7.03812L1.76466 0.802764C1.36096 0.399079 0.706449 0.399079 0.302764 0.802764C-0.100921 1.20645 -0.100921 1.86096 0.302764 2.26464L6.53812 8.5L0.302764 14.7353C-0.100921 15.1391 -0.100921 15.7935 0.302764 16.1973C0.706449 16.6009 1.36096 16.6009 1.76466 16.1973L8 9.96188L14.2354 16.1973C14.639 16.6009 15.2936 16.6009 15.6972 16.1973C16.1009 15.7935 16.1009 15.1391 15.6972 14.7353L9.46188 8.5L15.6972 2.26464Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.2c5430176d64c2e1db3d9f05060f3f28.svg";
export { ForwardRef as ReactComponent };